import { api } from '../../core/network/api';

/**
 * Player cards (E6, §4.4) — "meta layer only": a frame/background/badge behind a player's name
 * on the scoreboard and career screen, never a wire payload. `PlayerCardsController`'s three
 * routes. Equip is global, same as a charm.
 */
export interface PlayerCardEntry {
  id: number;
  name: string;
  description: string;
  /** 0xrrggbb — the card's border. */
  frame: number;
  /** 0xrrggbb — the card's fill. */
  background: number;
  /** Icon-atlas key for the corner badge. May not resolve to shipped art yet — render with a
   * graceful fallback to the card's own frame/background rather than a broken image. */
  badge: string;
  priceCoins: number;
  currency: 'PREMIUM';
  owned: boolean;
  equipped: boolean;
  affordable: boolean;
}

export interface PlayerCardCatalogueView {
  equippedCard: number;
  cards: PlayerCardEntry[];
}

/** `GET /player-cards`. */
export const fetchPlayerCardsCatalogue = () => api.get<PlayerCardCatalogueView>('/player-cards');

/** `POST /player-cards/purchase`. */
export const purchasePlayerCard = (card: number) =>
  api.post<{ equippedCard: number }>('/player-cards/purchase', { card });

/** `POST /player-cards/equip` — `card: 0` (`NO_CARD`) restores Standard Issue. */
export const equipPlayerCard = (card: number) => api.post<{ equippedCard: number }>('/player-cards/equip', { card });
